import React from 'react';

interface SettingsCardProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const SettingsCard: React.FC<SettingsCardProps> = ({ title, children, className = '', style }) => {
  return (
    <div className={`bg-white rounded-2xl shadow-sm border border-slate-200/80 p-6 relative overflow-hidden ${className}`} style={style}>
      {/* Soft left accent */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-emerald-400/40 to-slate-200/60 rounded-l-2xl" aria-hidden />
      {title != null && title !== '' && (
        <h3 className="text-lg font-semibold text-slate-800 mb-4 pl-1">{title}</h3>
      )}
      <div className="relative">{children}</div>
    </div>
  );
};

export default SettingsCard;

